import { render, staticRenderFns } from "./ExpedienteForm.vue?vue&type=template&id=f808d062&"
import script from "./ExpedienteForm.vue?vue&type=script&lang=js&"
export * from "./ExpedienteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports